import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      // 現在のページにセクションがない場合はホームへ遷移してスクロール
      navigate("/");
      setTimeout(() => {
        const target = document.getElementById(id);
        if (target) target.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <footer className="bg-[#0f1720] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {/* Brand */}
          <div>
            <div className="mb-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/936a3815-94a7-4322-ba1f-21b9078bb21c.png"
                  alt="SHOP-MK logo"
                  className="w-full h-full object-contain brightness-0 invert"
                />
              </div>
              <p className="font-black text-2xl tracking-widest">SHOP-MK</p>
            </div>
            <div className="flex items-center gap-3">
              {["ri-linkedin-box-line", "ri-twitter-x-line", "ri-facebook-box-line", "ri-instagram-line"].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:border-white/60 hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.3em] text-white/40 mb-5">
              <a id="quick-links">{t("footer.quickLinks")}</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  {t("nav.about")}
                </Link>
              </li>
              {[
                { key: "nav.services", id: "services" },
                { key: "nav.partners", id: "partners" },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    {t(item.key)}
                  </button>
                </li>
              ))}
              <li>
                <Link
                  to="/process"
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  {t("process.navLink")}
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollTo("contact")}
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  {t("nav.contact")}
                </button>
              </li>
            </ul>
          </div>

          {/* Office section removed */}
        </div>
      </div>

      {/* Legal Links */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            <Link
              to="/privacy-policy"
              className="text-xs text-white/40 hover:text-white/70 transition-colors"
            >
              {t("footer.privacy")}
            </Link>
            <span className="text-white/20 hidden sm:inline">|</span>
            <Link
              to="/terms"
              className="text-xs text-white/40 hover:text-white/70 transition-colors"
            >
              {t("footer.terms")}
            </Link>

          </div>
          <p className="text-xs text-white/30">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}